import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from 'app';

interface VideoState {
  visible: boolean;
  data: string;
}

const initialState: VideoState = {
  visible: false,
  data: '',
};

const videoSlice = createSlice({
  name: 'video',
  initialState,
  reducers: {
    openVideoModal(
      state,
      action: PayloadAction<{
        data: string;
      }>
    ) {
      state.visible = true;
      state.data = action.payload.data;
    },
    cancelVideoModal(state) {
      state.visible = false;
      state.data = '';
    },
  },
  extraReducers: {},
});

const { actions, reducer: videoReducer } = videoSlice;

export const { openVideoModal, cancelVideoModal } = actions;

export default videoReducer;

export const selectVideo = (state: RootState): VideoState =>
  state.video as VideoState;
